<template lang="pug">
main.monitoring-main
    sectionHeader.section-header-monitoring(title='Audiences & Transfers')
        template(slot="action")
            <el-dropdown trigger="click" style="margin-left: 15px" placement="bottom-end" @command="handleCommand">
                <button class="btn-border btn--round l-flex-row l-align-center" style="height: 32px;padding: 0 8px;">
                    | Audience actions
                    <svg-icon class="sub-navigation-cta-icon is-white" name="dots" size="small" style="margin-right: -5px;" />
                </button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="export" class="l-flex-row dropdown-menu-action">
                        <span>Audiences export</span>
                    </el-dropdown-item>
                    <template v-if="selectedAudienceId && monitoringActionAllowed">
                        <el-dropdown-item divided />
                        <el-dropdown-item command="transfer" class="l-flex-row dropdown-menu-action">
                            <span>Add Transfer</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="displayBootstrapAction" command="bootstrap" class="l-flex-row dropdown-menu-action">
                            <span>Bootstrap</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="volumeAlert.label" :disabled="volumeAlertLoading" style="gap:6px;" command="alert" class="l-flex-row dropdown-menu-action">
                            <span>{{ volumeAlert.label }}</span>
                            <spinner v-if="volumeAlertLoading" style="margin-top: 5px" width="20" height="20" />
                        </el-dropdown-item>
                        <el-dropdown-item command="delete" class="l-flex-row dropdown-menu-action">
                            <span>Delete</span>
                        </el-dropdown-item>
                    </template>
                </el-dropdown-menu>
            </el-dropdown>
    div.section-search-update-delete(:class="{'edit-delete-is-allowed' : getIsMonitoringActionAllowed()}")
        div.l-flex-row.bulk-actions(:disabled="bulkSelectedRows < 1" v-if="getIsMonitoringActionAllowed()")
            svg-icon.cursor(title="edit rows" name='edit' size="medium" @click.native="displayBulkEditForm(true, false)")
            svg-icon.cursor(v-if="monitoringActionAllowed" title="delete rows" name='trash' size="medium" @click.native="displayBulkEditForm(true, true)")
        div.dashboard-search-wrapper
            Search(
                    :query="queryFilter"
                    :queryType="queryTypeFilter"
                    :types="searchTypes"
                    :sortByScore="false"
                    allTypeSearch
                    @queryChange="queryFilter = $event"
                    @queryTypeChange="queryTypeFilter = $event"
                    @filterChange="handleFilterQueryChange"
                    @reset="componentHandleQueryReset"
                )

            .filters-wrapper(style="margin-left: 15px")
                    button.btn-simple.small.btn-table-filters(
                        :class="{ 'is-highlighted': showFilters }"
                        title="Display filters"
                        @click="toggleFilter"
                    )
                        svg-icon(name='filter' size='small')

    .filters-wrapper-list.l-flex(v-show="showFilters")
        div.filters-wrapper-list_top
            div.l-flex-row.filter-item.filter-status.filter-item-wrapper
                .filter-label
                    svg-icon(name='filter', size='small')
                    SelectFilter(
                        v-model='statusFilter',
                        property='status',
                        label='Status',
                        :options='[ { key: "active", label: "Active" }, { key: "inactive", label: "Inactive" }]',
                        @filterChange='handleFilterFnChange("statusFilterFn", $event)'
                    )
            div.l-flex-row.filter-item.filter-status.filter-item-wrapper
                .filter-label
                    svg-icon(name='bootstrap', size='small')
                    SelectFilter(
                        v-model='bootstrapFilter',
                        property='bootstrap',
                        label='Bootstrap',
                        :options='[{ key: "attributed", label: "Attributed" },{ key: "failed", label: "Failed" }, { key: "processing", label: "Processing" },{ key: "attribute", label: "Attribute" },{ key: "none", label: "None" }]',
                        @filterChange='handleFilterFnChange("bootstrapFilterFn", $event)'
                    )
            div.l-flex-row.filter-item.filter-status.filter-item-wrapper
                .filter-label
                    svg-icon(name='filter', size='small')
                    SelectFilter(
                        v-model='typeFilter',
                        property='type',
                        label='Type',
                        :options='[{ key: "cclones", label: "Cclone" },{ key: "georadar", label: "Georadar" }]',
                        @filterChange='handleFilterFnChange("typeFilterFn", $event)'
                    )
            div.l-flex-row.filter-item.filter-status.filter-item-wrapper
                .filter-label
                    svg-icon(name='share', size='small')
                    SelectFilter(
                        v-model='sharedFilter',
                        property='isShared',
                        label='Shared',
                        :options='[{ key: true, label: "Yes" }, { key: false, label: "No" }]',
                        @filterChange='handleFilterFnChange("sharedFilterFn", $event)'
                    )

        div.filters-wrapper-list_btm
            .filter-item-wrapper.l-flex-row(v-for='dateFilter in dateFilters', :key='dateFilter.key')
                //- extra calendars
                .filter-item.filter-date
                    .filter-label
                        svg-icon(:name='dateFilter.icon.name', :size='dateFilter.icon.size')
                        .filter-text {{ dateFilter.from.label }}
                    .filter-date-combo.l-flex-row
                        select.select-operator(v-model='operators[dateFilter.key]' @change='changeOperator(dateFilter.key)')
                            option(v-for='operator in filterDateOperators', :key='operator.value', :value='operator.value') {{ operator.label }}
                        el-date-picker(
                            type='date',
                            v-model='dateFiltersVModelFromValues[dateFilter.key]',
                            :placeholder='dateFilter.from.placeholder',
                            @change='handleFromDate(dateFilter.key, $event)',
                            :picker-options='{disabledDate: (time) => disabledpickerOptionsFromDate(time,dateFilter.key)}'
                        )

                        .filter-date-to(v-if='displayTo[dateFilter.key]')
                            .filter-text-to {{ dateFilter.to.label }}
                            el-date-picker(
                                v-model='dateFiltersVModelToValues[dateFilter.key]',
                                type='date',
                                :placeholder='dateFilter.to.placeholder',
                                @change='handleToDate(dateFilter.key, $event)',
                                :picker-options='{disabledDate: (time) => disabledpickerOptionsToDate(time,dateFilter.key)}'
                            )

        div.filters-wrapper-list_btm
            .filter-item.filter-status.filter-item-wrapper.l-flex-row(style="width: 96%")
                .filter-item.filter-status(style="margin-right: 15px")
                    .filter-label
                        svg-icon(name='filter', size='small')
                        .filter-text(style="white-space: nowrap;") Partners
                    el-select.filter-partners.no-media-query(
                        v-model="partnersValue"
                        multiple
                        filterable
                        default-first-option
                        collapse-tags
                        placeholder="Filter by partners"
                    )
                        el-option(
                            v-for="item in partnerList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label"
                        )
                .filter-item.filter-status(style="margin-right: 15px")
                    .filter-label
                        svg-icon(name='filter', size='small')
                        .filter-text(style="white-space: nowrap;") Transfer label
                    el-input.filter-partners.no-media-query(
                        v-model="transferValue"
                        placeholder="Filter by transfer label"
                    )
                .filter-item.filter-status(style="margin-right: 15px")
                    .filter-label
                        svg-icon(name='filter', size='small')
                        .filter-text(style="white-space: nowrap;") Transfer ID
                    el-input.filter-partners.no-media-query(
                        v-model="transferId"
                        placeholder="Filter by transfer id"
                    )
                .filter-item.filter-status(style="margin-right: 15px")
                    .filter-label
                        svg-icon(name='filter', size='small')
                        .filter-text(style="white-space: nowrap;") Reference ID
                    el-input.filter-partners.no-media-query(
                        v-model="referenceIdValue"
                        placeholder="Filter by transfer's reference id"
                    )

            .filter-item.search-filters-reset(
                @click='resetFilters()'
            )
                svg-icon(name='reload', size='small', title='reset filters', @click.native='resetFilters()')

    //- Bulk edit Form
    .overlay-close(v-if='displayModal.bulkEdit', :class="{'disabled' : isUpdatedOrDeletedLoading}" ,@click='displayBulkEditForm(false)')
    .modal.modal-h-medium.modal-form-audience(v-if='displayModal.bulkEdit', :class="{'disabled' : isUpdatedOrDeletedLoading}" )
        BulkEditForm(:bulkList="bulkSelectedRows" @bulkEditFinished="clearSelection()" :isDelete="isDeleteForm")


    //- Table
    template(v-if="audienceList.length === 0")
        .no-results No results found

    template(v-else)
        ElTable.dashboard-table.monitoring-table.cursor(
            :data='paginatedData',
            ref="tableData",
            row-key="id"
            :key="refresh"
            header-row-class-name='dashboard-table-header-row',
            header-cell-class-name='dashboard-table-header-cell',
            cell-class-name='dashboard-tb-cell',
            empty-text='No audience available',
            :max-height='tableMaxHeight'
            :default-sort='{ order: sortOrder, prop: sortBy }',
            :expand-row-keys="expandedRows"
            @sort-change="componentHandleSortChange"
            @row-click="handleRowClick"
            @selection-change="handleSelectionChange"
            @expand-change="handleExpandChange"
            :row-class-name="rowStyle"
            :class="{'table-is-empty' : paginatedData.length === 0, 'is-shrinked': showFilters}"
        )


            ElTableColumn(width="20")
                template(slot-scope="scope" v-if="audienceAttachedTransfers(scope.row.id)")
                    .expand-icon-wrapper(@click.stop="toggleExpandRow(scope.row)")
                        svg-icon(name="angleRight" :rotation="isExpanded(scope.row) ? '90' : undefined")
            ElTableColumn(type="expand" width="1" align="right")
                template(slot-scope="scope" v-if="audienceAttachedTransfers(scope.row.id)")
                    ElTable.children-table-wrapper-transfers(
                        :data='audienceAttachedTransfers(scope.row.id)',
                        row-key="id"
                        header-row-class-name='dashboard-table-header-row',
                        header-cell-class-name='dashboard-table-header-cell',
                        cell-class-name='dashboard-tb-cell',
                    )
                        ElTableColumn(label='Id', prop='id', width='80')
                        ElTableColumn(label='Label', prop='label')
                            template(slot-scope="scope")
                                div.full-width(:title="scope.row.label")
                                    p.is-truncate {{ scope.row.label }}
                        ElTableColumn(label='Partner', prop='partner')
                        ElTableColumn(label='Partner Configuration', prop='partnerConfiguration' min-width="130")
                        template(
                            v-if="haveGoogleDDPPartner(audienceAttachedTransfers(scope.row.id))"
                        )
                            ElTableColumn(label='Reference ID', min-width="50")
                                template(slot-scope="subScope")
                                    span.is-truncate(:title="subScope.row.reference_id ? subScope.row.reference_id : ''") {{ subScope.row.reference_id ? subScope.row.reference_id : '-' }}
                            ElTableColumn(label='CPM', prop='cpm' min-width="50")
                                template(slot-scope="subScope")
                                    span {{ subScope.row.cpm ? subScope.row.cpm : '-' }}
                        ElTableColumn(label='Added on', prop='createdAt', width='105')
                            template(slot-scope="scope")
                                div
                                    p.is-truncate(:title="scope.row.createdAt") {{ formatDate(scope.row.createdAt) }}
                        ElTableColumn(label='End Date', prop='endDate', width='105')
                        ElTableColumn(label='Push of stock', prop='bootstrap_status', width='160')

            ElTableColumn(type='selection', width='40' reserve-selection)

            ElTableColumn(label='Id', prop='id', width='80', :sort-method='sortColumnBy("id")', sortable)

            ElTableColumn(prop='isShared', width='25')
                template(slot-scope="scope")
                    svg-icon.row-icon-share-label(v-if="scope.row.isShared" name='share' size='small')

            ElTableColumn(
                label='Label',
                class-name='ft-w-med word-break-normal',
                prop='label'
                :sort-method='sortColumnBy("label")',
                sortable
            )
                template(slot-scope="scope")
                    div.full-width
                        div.l-flex-row.l-align-center
                            div.row-item-status(:class="scope.row.status === 'inactive' ? 'item-inactive' : 'item-active'")
                            div.is-truncate(:title="scope.row.label") {{ scope.row.label }}
                        MonitoringTags(v-if="hasTags(scope.row)" :queryFilter="queryFilter" :queryTypeFilter="queryTypeFilter" :tags="scope.row.tags" @filterBySelectedTag="handleFilterBySelectedTag")

            ElTableColumn(label='Added on', width='130', prop='createdAt', :sort-method='sortColumnBy("createdAt")', sortable)
                template(slot-scope='scope')
                    div.is-truncate-100(:title="scope.row.createdAt") {{ scope.row.createdAt }}

            ElTableColumn(label='End date', width='130', prop='endDate', :sort-method='sortColumnBy("endDate")', sortable)
                template(slot-scope='scope') {{ formatDate(scope.row.endDate) }}

            ElTableColumn(label='Bootstrap', width='100' prop='bootstrap')

            ElTableColumn(label='Volume',  align='center' :min-width="volumeColumnWidth")
                <template slot="header">
                    <div class="l-flex-row--between">
                        div(style="width: 50%; text-align: right") Volumes
                        div.l-flex-row.filter-item.filter-status.filter-item-wrapper.ml-10
                            template(v-if="xDeviceSetting")
                                .filter-label
                                    el-radio-group(v-model="volumeFilter" name="devicedisplay" size="mini")
                                        el-radio-button(
                                            v-for="(option, index) in volumeOptions"
                                            name="devicedisplay"
                                            :key="index"
                                            class="btn-radio"
                                            :label="option.key"
                                            :value="option.key"
                                        ) {{ option.label }}
                            span(v-else class="txt value") ID Based
                    </div>
                </template>
                template(slot-scope='scope')
                    CellVolume(parent='monitoring' :data="scope.row.volume" :fullData="scope.row" :type="volumeFilter" @volume-change="setCurrentVolumes")

        ElPagination(
            background,
            layout='prev, pager, next, sizes',
            :total='filteredData.length',
            :page-size.sync='pageSize',
            :current-page.sync='currentPage',
            @current-change="currentPageChange"
            :page-sizes='[5, 10, 25, 50, 100]'
        )
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { RadioButton, RadioGroup } from 'element-ui'

// Library
import { cloneDeep, isEmpty, isNil } from 'lodash'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

// Constants
import { AUDIENCES_FILTERS_PROPS, FILTER_DATE_OPERATORS, FILTERING_DEFAULT_DATES } from '@/utils/constants'

// Components

import Table from '@/components/common/Table'
import SectionHeader from '@/components/common/SectionHeader'
import CellVolume from '@/components/monitoring/CellVolume'
import MonitoringTags from '@/components/monitoring/MonitoringTags'
import Search from '@/components/common/Search'
import SelectFilter from '@/components/common/SelectFilter'
import BulkEditForm from '@/components/monitoring/BulkEditForm'

import tablePaginationMixin from '@/mixins/tablePaginationMixin'
import tableOrderMixin from '@/mixins/tableOrderMixin'
import { get } from 'lodash'

import { formatDate } from '@/utils/helpers'

export default {
    name: 'Audiences',

    mixins: [tablePaginationMixin, tableOrderMixin],

    components: {
        Table,
        SectionHeader,
        CellVolume,
        Search,
        SelectFilter,
        BulkEditForm,
        MonitoringTags,
        'el-radio-button': RadioButton,
        'el-radio-group': RadioGroup,
    },

    mounted() {
        this.infos = { selectedTagLabel: this.selectedTagLabel, isAudienceCcloneTargeted: this.isAudienceCcloneTargeted }
        this.dateFilters = [
            {
                icon: { name: 'calendar', size: 'small' },
                dates: cloneDeep(this.filterStartDate),
                key: 'filterStartDate',
                from: { label: 'Start', placeholder: this.createdOrStartDateFromDefaultValue, pickerOptions: this.pickerOptionsStartOrCreatedFrom },
                to: { label: 'to', placeholder: this.newDate, pickerOptions: this.pickerOptionsStartOrCreatedTo }
            },
            {
                icon: { name: 'calendar', size: 'small' },
                dates: cloneDeep(this.filterEndDate),
                key: 'filterEndDate',
                from: { label: 'End', placeholder: this.newDate, pickerOptions: null },
                to: { label: 'to', placeholder: this.newDate, pickerOptions: this.pickerOptionsEndTo }
            }
        ]
        this.updateVolumeFilter()

        this.retrieveVolumes({ paginatedData: this.paginatedData })

        window.addEventListener('resize', () => {
            this.windowHeight = window.innerHeight
        })
    },

    watch: {
        activeStatus: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                if(newValue) {
                    this.resetFilters()
                    this.statusFilter = 'active'
                    this.showFilters = newValue
                }
            }
        },
        isExpiringAudiences: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                if(newValue) {
                    this.resetFilters()
                    const thirtyDaysFromNow = dayjs().toDate()
                    const thirtyDaysToNow = dayjs().add(30, 'day').toDate()
                    this.operators['filterEndDate'] = 'period'
                    this.dateFiltersVModelFromValues = {
                        filterEndDate: thirtyDaysFromNow,
                    }
                    this.dateFiltersVModelToValues = {
                        filterEndDate: thirtyDaysToNow,
                    }
                    this.statusFilter = 'active'
                    this.showFilters = newValue
                }
            }
        },
        selectedTagLabel: {
            handler: function(newValue) {
                this.infos.selectedTagLabel = newValue
            }
        },

        isAudienceCcloneTargeted: {
            handler: function(newValue) {
                this.infos.isAudienceCcloneTargeted = newValue
            }
        },

        typeVolume: {
            handler: function(newValue) {
                this.setTypeVolume({ type: newValue })
            }
        },

        paginatedData: {
            handler: function(newValue) {
                this.retrieveVolumes({ paginatedData: newValue })
            }
        },

        changeRowData: {
            async handler(value) {
                if (value && value.id && this.bulkSelectedRows.length > 0) {
                    let selected = await this.bulkSelectedRows.find(selected => selected.id === value.id)
                    if (selected) selected = Object.assign(selected, value)
                    this.setChangeRowData(null)
                }
            },
            deep: true
        },

        resetBulkSelectedRows: {
            handler: function(newValue) {
                if (newValue && this.bulkSelectedRows.length > 0) {
                    this.bulkSelectedRows = []
                    this.clearSelection()
                }
            }
        },

        xDeviceInfo: {
            handler(value) {
                // init idbased when we switch off crossoptions
                this.refresh += 1
                if (value && value.status !== 'active') this.volumeFilter = 'idbased'
            },
            deep: true
        },
        selectedAudienceId: {
            immediate: true,
            handler() {
                if (this.selectedRowFrom === 'other-page') {
                    this.resetFilters()
                    this.queryFilter = this.selectedAudienceId.toString()
                }
            }
        }
    },

    data() {
        return {
            //ACTIONS
            actions: {
                retrieveVolumes: async paginatedData => await this.retrieveVolumes({ paginatedData }),
                updateFilteredData: async items => await this.setFilteredData({ items }),
                updateTargetedCcloneAudience: async value => await this.setIsAudienceCcloneTargeted({ value }),
                resetTagSearch: async () => await this.setSelectedTag({ tagLabel: '' })
            },
            infos: {},
            expand: false,
            expanding: [],
            refresh: 0,

            // FILTERS
            filtersData: {
                filters: cloneDeep(AUDIENCES_FILTERS_PROPS),
                filterTargets: { bootstrap: '', status: '', type: '', shared: '', type_volume: '' }
            },

            // DATE FILTERS
            dateFilters: [],
            filterDateOperators: FILTER_DATE_OPERATORS,
            filterStartDate: cloneDeep(FILTERING_DEFAULT_DATES.start),
            filterEndDate: cloneDeep(FILTERING_DEFAULT_DATES.end),
            defaultDates: cloneDeep(FILTERING_DEFAULT_DATES),

            // Table utils
            defaultSortBy: 'id',
            secondSortBy: 'createdAt',
            sortBy: 'id',
            queryFilter: '',
            queryTypeFilter: null,
            searchTypes: { id: 'id', label: 'label', 'tags.label': 'tag' },
            queryFilterFn: data => data,
            showFilters: false,
            statusFilter: null,
            statusFilterFn: () => true,
            bootstrapFilter: null,
            bootstrapFilterFn: () => true,
            typeFilter: null,
            typeFilterFn: () => true,
            volumeFilter: 'idbased',
            volumeFilterFn: () => true,
            sharedFilter: null,
            sharedFilterFn: () => true,
            partnersValue: null,
            transferValue: null,
            transferId: null,
            referenceIdValue: null,
            operators: {
                filterEndDate: 'equal',
                filterStartDate: 'equal'
            },
            dateFiltersVModelFromValues: {},
            dateFiltersVModelToValues: {},
            bulkSelectedRows: [],
            isDeleteForm: false,
            showFilterOnce: false,
            showFilterPartnerWhenEmpty: false,
            showFilterTransferWhenEmpty: false,
            windowHeight: window.innerHeight,
            currentVolumes: []
        }
    },

    activated() {
        this.updateVolumeFilter()
    },

    computed: {
        ...mapState('data/audience', {
            audienceList: state => state.list,
            isUpdatedOrDeletedLoading: state => state.isUpdatedOrDeletedLoading,
            resetBulkSelectedRows: state => state.resetBulkSelectedRows
        }),
        ...mapState('dashboardAccount', {
            activeStatus: state => {
                return state.activeStatus
            },
            isExpiringAudiences: state => {
                return state.isExpiringAudiences
            }
        }),
        ...mapState('data/transfer', {
            transfers: state => state.list
        }),
        ...mapState('ui/monitoring', {
            displayModal: state => state.displayModal,
            selectedAudienceId: state => state.selectedRowId,
            expandedRows: state => state.expandedRows,
            selectedTagLabel: state => state.selectedTagLabel,
            isAudienceCcloneTargeted: state => state.isAudienceCcloneTargeted,
            selectedRowFrom: state => state.selectedRowFrom,
            genericFormulaVolumes: state => state.formulaVolumes,
            selectedAudienceHaveDeletedCriteria: state => state.selectedAudienceHaveDeletedCriteria,

        }),
        ...mapState('account', {
            xDeviceInfo: state => state.xDeviceInfo,
            attributionCounterAudience: state => state.attributionCounterAudience,
            dailyBootstrapLimit: state => state.dailyBootstrapLimit
        }),
        ...mapState('data/dsp', {
            dspList: state => state.list
        }),
        ...mapState('ui/builder', {
            formulaLoading: state => state.isLoading.volumes
        }),
        ...mapGetters('data/audience', ['changeRowData']),

        ...mapGetters('account', ['getIsMonitoringActionAllowed']),
        ...mapGetters('ui/builder', ['getThirdPartyOnlyInAudienceFormula']),

        // DATE FILTERS
        newDate() {
            return formatDate(new Date())
        },
        createdOrStartDateFromDefaultValue() {
            return formatDate(dayjs(this.newDate))
        },
        pickerOptionsStartOrCreatedFrom() {
            return {
                disabledDate(time) {
                    return time ? time.getTime() > Date.now() : null
                }
            }
        },
        pickerOptionsStartOrCreatedTo() {
            const _filterStartDate = this.filterStartDate
            return {
                disabledDate(time) {
                    return time && _filterStartDate.from ? time.getTime() > Date.now() || time.getTime() < _filterStartDate.from.getTime() : null
                }
            }
        },
        pickerOptionsEndTo() {
            const _filterEndDate = this.filterEndDate
            return {
                disabledDate(time) {
                    return time && _filterEndDate.from ? time.getTime() < _filterEndDate.from.getTime() : null
                }
            }
        },
        typeVolume() {
            return this.filtersData.filterTargets.type_volume
        },

        //Table
        filteredData() {
            let filteredData = this.audienceList
            if (this.queryFilter !== null && this.queryFilter?.trim() !== '') {
                filteredData = filteredData.filter(item => {
                    let condition = false
                    if (this.queryTypeFilter === null || this.queryTypeFilter === 'label') {
                        condition = condition || item?.label?.toLowerCase().includes(this.queryFilter?.toLowerCase())
                    }

                    if (this.queryTypeFilter === null) {
                        condition = condition || (item?.id && `${item.id}`.includes(this.queryFilter))
                    } else if (this.queryTypeFilter === 'id') {
                        condition = condition || (item?.id && `${item.id}`.startsWith(this.queryFilter))
                    }

                    if (this.queryTypeFilter === null || this.queryTypeFilter === 'tags.label') {
                        condition = condition || item?.tags?.some(tag => tag.label.toLowerCase().includes(this.queryFilter?.toLowerCase()))
                    }

                    this.setActiveStatus(false)
                    this.setIsExpiringAudiences(false)
                    return condition
                })
            }

            this.setActiveStatus(false)
            this.setIsExpiringAudiences(false)
            return filteredData
                .filter(item => this.statusFilterFn(item))
                .filter(item => this.bootstrapFilterFn(item))
                .filter(item => this.typeFilterFn(item))
                .filter(item => this.sharedFilterFn(item))
                .filter(item => this.partnersFilterFn(item))
                .filter(item => this.transferFilterFn(item))
                .filter(item => this.dateFiltersFn(item))
        },

        sortedData() {
            const rows = [...this.filteredData]
            return rows.sort(this.sortColumnBy(this.sortBy))
        },

        paginatedData() {
            return this.paginate(this.sortedData)
        },

        partnerList() {
            const partners = []
            this.dspList.forEach(partner => {
                partners.push({
                    label: partner.label,
                    value: partner.keyLabel
                })
            })
            return [...partners, { value: 'Pixel URL', label: 'Pixel URL' }]
        },

        displayTo() {
            return {
                filterStartDate: this.operators.filterStartDate === 'period',
                filterEndDate: this.operators.filterEndDate === 'period'
            }
        },

        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },

        crosseDeviceIsSelected() {
            const { status } = this.xDeviceInfo
            return this.volumeFilter === 'crossdevice' && status === 'active'
        },

        volumeOptions() {
            const { status } = this.xDeviceInfo
            const options = [
                { key: 'idbased', label: 'ID Based' },
                { key: 'crossdevice', label: 'Cross device' },
            ]
            if (this.xDeviceInfo && status !== 'active') options.shift()
            return options
        },

        tableMaxHeight() {
            const height = this.showFilters ? this.windowHeight - 445 : this.windowHeight - 280
            return `${height}px`
        },

        xDeviceSetting() {
            return this.xDeviceInfo && this.xDeviceInfo.status === 'active'
        },

        volumeColumnWidth() {
            const widthPerVolume = 96 * this.currentVolumes.length
            // let audienceIsSelected = 0
            // if (this.currentVolumes.length > 4) {
            //     audienceIsSelected = this.selectedAudienceId === null ? 0 : 30 * this.volumeOptions.length
            // }
            return widthPerVolume
        },
        ...mapState('ui/settings', {
            bootstrapPush: state => state.general.bootstrapPush
        }),
        ...mapGetters('data/audience', ['getItemById']),
        ...mapGetters('account', ['getUserAccess']),

        ...mapState('account', {
            userRole: state => state.userRole,
        }),

        // Volume Alert
        volumeAlertLoading() {
            return this.audienceInfo.volumeAlert.isLoading
        },

        volumeAlert() {
            if (isEmpty(this.audienceInfo.volumeAlert.details)) {
                return {
                    label: 'Create volume alert ',
                    action: this.volumeAlertLoading ? null : this.addVolumeAlert
                }
            }
            return {
                label: 'Edit volume alert',
                action: this.volumeAlertLoading ? null : this.displayEditFormVolumeAlert
            }
        },

        audienceInfo() {
            const _info = this.getItemById({ id: this.selectedAudienceId })
            // @TODO error notificationselectedAudienceHaveDeletedCriteria
            return _info == false ? null : _info
        },

        displayBootstrapAction() {
            if (this.audienceInfo) {
                const canShowBootstrap = this.audienceInfo.shouldShowBootstrap({
                    bootstrapPush: this.bootstrapPush,
                    managerAccess: this.getUserAccess({ type: 'manager_access' }),
                    userRole: this.userRole
                })

                const isNotThirdPartyBootstrap = !this.audienceInfo.isThirdPartyBootstrap({
                    bootstrapPush: this.bootstrapPush,
                    managerAccess: this.getUserAccess({ type: 'manager_access' }),
                    userRole: this.userRole
                })

                const asNoBootstrap = this.audienceInfo.bootstrap === 'none'

                const isBootstrapAllowed = this.audienceInfo.isBootstrapAllowed({
                    userRole: this.userRole,
                    getThirdPartyOnlyInAudienceFormula: this.getThirdPartyOnlyInAudienceFormula
                })

                const dailyQuotaNotBeenReached =
                    this.userRole === 'webo_admin' ||
                    this.attributionCounterAudience + get(this.genericFormulaVolumes, `${this.selectedAudienceId}`, 0) < this.dailyBootstrapLimit

                return (
                    canShowBootstrap &&
                    isNotThirdPartyBootstrap &&
                    asNoBootstrap &&
                    isBootstrapAllowed &&
                    dailyQuotaNotBeenReached &&
                    !this.formulaLoading &&
                    !this.selectedAudienceHaveDeletedCriteria
                )
            }
            return false
        },
    },

    methods: {
        ...mapMutations('ui/monitoring', [
            'setSelectedRow',
            'setActiveTab',
            'setFilteredData',
            'setExpandedRows',
            'setExpandedTableRows',
            'setIsAudienceCcloneTargeted',
            'setTypeVolume',
            'setSelectedTag',
            'setDisplayModal',
            'setDeletedAudienceId'
        ]),
        ...mapActions('data/audience', ['retrieveVolumes', 'resetEditBulkForm']),
        ...mapMutations('data/audience', ['setResetBulkSelectedRows', 'setChangeRowData']),
        ...mapMutations('ui/volumeAlert', ['setShowVolumeAlertForm', 'setIsEditVolumeAlert']),
        ...mapMutations('dashboardAccount', ['setActiveStatus', 'setIsExpiringAudiences']),

        addVolumeAlert() {
            this.setIsEditVolumeAlert({ isEdit: false })
            this.setShowVolumeAlertForm({ show: true })
        },

        bootstrapAudience() {
            this.$emit('trigger-bootstrap')
        },

        displayEditFormVolumeAlert() {
            this.setIsEditVolumeAlert({ isEdit: true })
            this.setShowVolumeAlertForm({ show: true })
        },
        ...mapMutations('exports', ['setExportForm']),

        ...mapMutations('ui/transfers', ['setShowFormTransfer', 'setShowFormCreateTransfer']),

        callTransferForm() {
            this.setShowFormTransfer({ show: true })
            this.setShowFormCreateTransfer({ show: true })
        },

        formatDate(date) {
            return formatDate(date)
        },

        updateVolumeFilter() {
            if (this.$store.state.data.settings.general.xdevice) {
                this.filtersData.filters.filter(filter => filter.key === 'type_volume')[0]['targets'] = cloneDeep(AUDIENCES_FILTERS_PROPS).filter(
                    filter => filter.key === 'type_volume'
                )[0]['targets']
            } else {
                this.filtersData.filters.filter(filter => filter.key === 'type_volume')[0]['targets'].splice(1, 1)
                this.setTypeVolume({ type: '' })
            }
        },

        updateDate(key, target, value) {
            if (key === 'filterStartDate') {
                this.filterStartDate[target] = value
            } else if (key === 'filterEndDate') {
                this.filterEndDate[target] = value
            }
        },

        handleRowClick(row, column, event) {
            if (['tag-more', 'volume-total'].includes(event.target?._prevClass)) return

            const selectedId = this.selectedAudienceId !== row.id ? row.id : null
            this.setSelectedRow({ rowId: selectedId })
            this.setActiveTab({ tab: 'information' })
        },

        rowStyle({ row }) {
            let styles = ''
            const transfers = this.audienceAttachedTransfers(row.id)
            if (row.id === this.selectedAudienceId) styles += 'selected-row-monitoring'
            if (!transfers || !transfers.length > 1) styles += ' hide-arrow'

            return styles
        },

        componentHandleSortChange(params) {
            this.currentPage = 1
            this.handleSortChange(params)
        },

        async handleFilterQueryChange({ fn }) {
            await this.$nextTick()
            this.queryFilterFn = fn
        },

        async componentHandleQueryReset() {
            await this.$nextTick()
            this.handleQueryReset(this.$refs.tableData)
        },

        async handleFilterFnChange(fn, value) {
            if (this.showFilterOnce) await this.setSelectedRow({ rowId: null })
            await this.$nextTick()
            this.currentPage = 1
            this[fn] = value
            this.showFilterOnce = true
        },

        partnersFilterFn(value) {
            /*  if (this.selectedRowFrom === 'other-page') {
                return
            } */
            if (!isEmpty(this.partnersValue)) {
                this.showFilterPartnerWhenEmpty = true
                this.setSelectedRow({ rowId: null })
                const transfers = this.$store.state.data.transfer.list
                const transfersList = transfers[value.id]
                if (transfersList) {
                    let hasOneOfTheRequiredDsp = false
                    for (const transfer of transfersList) {
                        if (this.partnersValue.includes(transfer.partner)) hasOneOfTheRequiredDsp = true
                        else if (this.partnersValue.includes('Pixel URL') && !isEmpty(transfer.pixel_url)) hasOneOfTheRequiredDsp = true
                    }
                    return hasOneOfTheRequiredDsp
                } else return false
            }
            if (isEmpty(this.partnersValue) && this.showFilterPartnerWhenEmpty) {
                this.showFilterPartnerWhenEmpty = false
                this.setSelectedRow({ rowId: null })
            }

            return true
        },

        transferFilterFn(value) {
            /* if (this.selectedRowFrom === 'other-page') {
                return
            } */

            if (!isEmpty(this.transferValue) || !isEmpty(this.referenceIdValue) || !isEmpty(this.transferId)) {
                this.showFilterTransferWhenEmpty = true
                this.setSelectedRow({ rowId: null })
                const transfers = this.$store.state.data.transfer.list
                const transfersList = transfers[value.id]
                if (transfersList) {
                    const filtredList = transfersList ? transfersList.filter((transfer) => {
                        const trfCdt = !isEmpty(this.transferValue) ? transfer.label.toLowerCase().includes(this.transferValue.toLowerCase()) : true
                        const idCdt = !isEmpty(this.transferId) ? `${transfer.id}`.includes(this.transferId.toString()) : true
                        const refCdt = !isEmpty(this.referenceIdValue) ? (
                            transfer?.reference_id?.toLowerCase().includes(this.referenceIdValue.toLowerCase())
                        ) : true

                        let partnerCdt = true

                        if (!isEmpty(this.partnersValue)) {
                            partnerCdt = this.partnersValue.includes(transfer.partner)
                        }
                        return (
                            trfCdt && refCdt && partnerCdt && idCdt
                        )
                    }) : []

                    return filtredList.length > 0
                } else return false
            }

            if (isEmpty(this.transferValue) && this.showFilterTransferWhenEmpty) {
                this.showFilterTransferWhenEmpty = false
                this.setSelectedRow({ rowId: null })
            }

            if (isEmpty(this.referenceIdValue) && this.showFilterTransferWhenEmpty) {
                this.showFilterTransferWhenEmpty = false
                this.setSelectedRow({ rowId: null })
            }

            if (isEmpty(this.transferId) && this.showFilterTransferWhenEmpty) {
                this.showFilterTransferWhenEmpty = false
                this.setSelectedRow({ rowId: null })
            }

            return true
        },

        haveGoogleDDPPartner(transfers) {
            return transfers.find(transfer => transfer.reference_id !== '') ? true : false
        },

        audienceAttachedTransfers(id) {
            let tansfers = this.transfers[id]

            if (!tansfers) return false

            if (!isEmpty(this.transferValue)) {
                tansfers = tansfers.filter(transfer => transfer.label.toLowerCase().includes(this.transferValue.toLowerCase()))
            }

            if (!isEmpty(this.transferId)) {
                tansfers = tansfers.filter(transfer => `${transfer.id}`.includes(this.transferId.toString()))
            }

            if (!isEmpty(this.partnersValue)) {
                tansfers = tansfers.filter(transfer => this.partnersValue.includes(transfer.partner))
            }

            if (!isEmpty(this.referenceIdValue)) {
                tansfers = tansfers.filter(transfer => {
                    if (transfer.reference_id) {
                        return transfer.reference_id.toLowerCase().includes(this.referenceIdValue.toLowerCase())
                    }
                    return false
                })
            }

            return tansfers
        },

        dateFiltersFn(value) {
            const keyStart = 'Start'
            const keyEnd = 'End'
            const createdDate = this.defaultDates.created
            const startDate = {
                from: this.dateFiltersVModelFromValues.filterStartDate,
                to: this.dateFiltersVModelToValues.filterStartDate,
                operator: this.operators.filterStartDate
            }
            const endDate = {
                from: this.dateFiltersVModelFromValues.filterEndDate,
                to: this.dateFiltersVModelToValues.filterEndDate,
                operator: this.operators.filterEndDate
            }

            // filter on date created
            if (!isNil(createdDate.from)) {
                const _dateKey = 'created_at'
                const createdDateFrom = formatDate(createdDate.from)
                const createdDateTo = formatDate(createdDate.to)

                if (createdDate.operator === 'equal' && !dayjs(value[_dateKey]).isSame(createdDateFrom, 'day')) {
                    return false
                } else if (createdDate.operator === 'before' && !dayjs(value[_dateKey]).isSameOrBefore(createdDateFrom, 'day')) {
                    return false
                } else if (
                    (createdDate.operator === 'after' || createdDate.operator === 'period') &&
                    !dayjs(value[_dateKey]).isBetween(createdDateFrom, createdDateTo, 'day', [])
                ) {
                    return false
                }
            }
            // filter on dates start/activation
            if (!isNil(startDate.from)) {
                const _dateKey = keyStart === 'Activation' ? 'start_date' : 'createdAt'

                const startDateFrom = formatDate(startDate.from)
                const startDateTo = formatDate(startDate.to)

                if (startDate.operator === 'equal' && !dayjs(value[_dateKey]).isSame(startDateFrom, 'day')) {
                    return false
                } else if (startDate.operator === 'before' && !dayjs(value[_dateKey]).isSameOrBefore(startDateFrom, 'day')) {
                    return false
                } else if (startDate.operator === 'after' && !dayjs(value[_dateKey]).isSameOrAfter(startDateFrom, 'day')) {
                    return false
                } else if (
                    (startDate.operator === 'after' || startDate.operator === 'period') &&
                    !dayjs(value[_dateKey]).isBetween(startDateFrom, startDateTo, 'day', [])
                ) {
                    return false
                }
            }
            // check on end or update date according to key param
            if (!isNil(endDate.from)) {
                const _dateKey = keyEnd === 'Update' ? 'updatedAt' : 'endDate'
                const endDateFrom = formatDate(endDate.from)
                const endDateTo = formatDate(endDate.to)

                if (endDate.operator === 'equal' && !dayjs(value[_dateKey]).isSame(endDateFrom, 'day')) {
                    return false
                } else if (endDate.operator === 'before' && !dayjs(value[_dateKey]).isSameOrBefore(endDateFrom, 'day')) {
                    return false
                } else if (endDate.operator === 'after' && !dayjs(value[_dateKey]).isSameOrAfter(endDateFrom, 'day')) {
                    return false
                } else if (endDate.operator === 'period' && !isNil(endDate.to) && !dayjs(value[_dateKey]).isBetween(endDateFrom, endDateTo, 'day', [])) {
                    return false
                }
            }
            return true
        },

        resetFilters() {
            this.volumeFilter = 'idbased'
            this.statusFilter = null
            this.bootstrapFilter = null
            this.typeFilter = null
            this.sharedFilter = null
            this.partnersValue = null
            this.transferValue = null
            this.transferId = null
            this.referenceIdValue = null
            this.resetDates()
        },

        resetDates() {
            this.dateFiltersVModelFromValues = {}
            this.dateFiltersVModelToValues = {}
            this.filterStartDate = cloneDeep(FILTERING_DEFAULT_DATES.start)
            this.filterEndDate = cloneDeep(FILTERING_DEFAULT_DATES.end)
            this.operators = {
                filterEndDate: 'equal',
                filterStartDate: 'equal'
            }
        },

        handleFromDate(filterKey, event) {
            this.dateFiltersVModelFromValues[filterKey] = event
            if (this.showFilterOnce) this.setSelectedRow({ rowId: null })
        },

        handleToDate(filterKey, event) {
            this.dateFiltersVModelToValues[filterKey] = event
            if (this.showFilterOnce) this.setSelectedRow({ rowId: null })
        },

        handleSelectionChange(val) {
            this.bulkSelectedRows = val
        },

        displayBulkEditForm(value, isDelete) {
            this.isDeleteForm = isDelete
            this.setDisplayModal({ item: 'bulkEdit', display: value })
        },

        toggleExpandRow(row) {
            this.$refs.tableData.toggleRowExpansion(row)
        },

        handleExpandChange(row) {
            this.setExpandedRows({ id: row.id })
        },

        isExpanded(row) {
            return this.expandedRows.includes(row.id)
        },

        hasTags(row) {
            return row?.tags?.length > 0
        },

        async clearSelection() {
            if (this.resetBulkSelectedRows) await this.resetEditBulkForm()
            this.$refs.tableData.clearSelection()
        },

        toggleFilter() {
            this.showFilters = !this.showFilters
            this.showFilterOnce = false
        },

        disabledpickerOptionsFromDate(time, key) {
            const filterFromEndDate = this.dateFiltersVModelFromValues.filterEndDate
            const filterFromStartDate = this.dateFiltersVModelFromValues.filterStartDate
            const filterToStartDate = this.dateFiltersVModelToValues.filterStartDate
            const filterToEndDate = this.dateFiltersVModelToValues.filterEndDate
            if (key === 'filterStartDate' && filterFromEndDate) {
                return time.getTime() > new Date(filterFromEndDate).getTime()
            } else if (key === 'filterStartDate' && filterToStartDate) {
                return time.getTime() > new Date(filterToStartDate).getTime()
            } else if (key === 'filterEndDate' && filterFromStartDate && filterToEndDate) {
                const start = time.getTime() < new Date(filterFromStartDate).getTime()
                const end = time.getTime() > new Date(filterToEndDate).getTime()
                return start || end
            } else if (key === 'filterEndDate' && filterFromStartDate) {
                return time.getTime() < new Date(filterFromStartDate).getTime()
            } else if (key === 'filterEndDate' && filterToEndDate) {
                return time.getTime() > new Date(filterToEndDate).getTime()
            } else if (key === 'filterStartDate') {
                return time.getTime() > Date.now()
            }
            return false
        },

        disabledpickerOptionsToDate(time, key) {
            const filterFromEndDate = this.dateFiltersVModelFromValues.filterEndDate
            const filterFromStartDate = this.dateFiltersVModelFromValues.filterStartDate
            if (key === 'filterStartDate' && filterFromStartDate) {
                return time.getTime() < new Date(filterFromStartDate).getTime() || time.getTime() > Date.now()
            } else if (key === 'filterStartDate') {
                return time.getTime() > Date.now()
            } else if (key === 'filterEndDate' && filterFromEndDate) {
                return time.getTime() < new Date(filterFromEndDate).getTime()
            }
            return false
        },

        changeOperator(key) {
            if (this.operators[key] === 'period' && this.dateFiltersVModelToValues[key]) this.dateFiltersVModelToValues[key] = ''
        },

        currentPageChange() {
            // since null doesnt exist, expanded row is expanded
            if (this.expandedRows.length > 0) this.setExpandedRows({ id: null })
        },

        handleFilterBySelectedTag(label) {
            this.queryFilter = label
            this.queryTypeFilter = 'tags.label'
        },

        setCurrentVolumes(volumes) {
            this.currentVolumes = volumes
        },
        deleteAudienceHandler() {
            this.setDisplayModal({ item: 'audience', display: true })
            this.setDeletedAudienceId({ audienceId: this.selectedAudienceId })
        },

        exportDataForm(type) {
            this.setExportForm({
                display: true,
                type
            })
        },

        handleCommand(command) {
            if (command === 'export') {
                this.exportDataForm('audience_monitoring')
                return
            }

            if (command === 'transfer') {
                this.callTransferForm()
                return
            }

            if (command === 'bootstrap') {
                this.bootstrapAudience()
                return
            }

            if (command === 'alert') {
                this.volumeAlert.action()
                return
            }

            if (command === 'delete') {
                this.deleteAudienceHandler()
                return
            }
        }
    }
}
</script>
